import { ADDRESS_REQUIRED_MESSAGES, DEFAULT_COUNTRY_CODE } from "../../../utils/addressData";

export function emptyAddress() {
  return {
    id: "",
    label: "",
    name: "",
    street: "",
    city: "",
    zip: "",
    country: DEFAULT_COUNTRY_CODE,
    forOutgoingInvoice: false,
  };
}

export function validateAddress(address) {
  const nextErrors = {};
  if (!address.label?.trim()) {
    nextErrors.label = "Bitte Bezeichnung angeben.";
  }
  if (!address.street?.trim()) nextErrors.street = ADDRESS_REQUIRED_MESSAGES.street;
  if (!address.zip?.trim()) nextErrors.zip = ADDRESS_REQUIRED_MESSAGES.zip;
  if (!address.city?.trim()) nextErrors.city = ADDRESS_REQUIRED_MESSAGES.city;
  if (!address.country?.trim()) nextErrors.country = ADDRESS_REQUIRED_MESSAGES.country;
  return nextErrors;
}

export function cryptoRandomId() {
  return typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2);
}
